import { __assign, __read } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import { Color } from '../../';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Circle from '@mui/icons-material/Circle';
import CircleTwoToneIcon from '@mui/icons-material/CircleTwoTone';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';
import { MarginProps, hasMarginProps } from '../../Style/Margin';
import { PaddingProps } from '../../Style/Padding';
import { useState } from 'react';
function RadioButtonIcon(props) {
    if (props === null || props === void 0 ? void 0 : props.disabled) {
        if (props === null || props === void 0 ? void 0 : props.checked) {
            return (_jsx(CircleTwoToneIcon, { sx: {
                    fill: Color.component.gray,
                } }));
        }
        else {
            return (_jsx(Circle, { sx: {
                    fill: Color.component.gray_light,
                } }));
        }
    }
    return (_jsx(CircleTwoToneIcon, { sx: {
            "circle": {
                fill: Color.component.gray,
            },
            "&:hover": {
                fill: Color.component.gray_dark,
            }
        } }));
}
var StyledComponent = styled(function (props) {
    var _a = __read(useState(props === null || props === void 0 ? void 0 : props.checked), 2), checked = _a[0], setChecked = _a[1];
    return (_jsx("div", { id: props === null || props === void 0 ? void 0 : props.id, "data-current-value": checked, children: _jsx(FormControlLabel, { "aria-label": "".concat(props === null || props === void 0 ? void 0 : props.ariaLabel, " FormControlLabel"), onChange: function (e, checked) {
                setChecked(checked);
                if (props === null || props === void 0 ? void 0 : props.onChange) {
                    props === null || props === void 0 ? void 0 : props.onChange(e, checked);
                }
            }, checked: props === null || props === void 0 ? void 0 : props.checked, disabled: props === null || props === void 0 ? void 0 : props.disabled, value: props === null || props === void 0 ? void 0 : props.value, name: props === null || props === void 0 ? void 0 : props.name, control: _jsx(Radio, { disableFocusRipple: true, disableRipple: true, "aria-label": "".concat(props === null || props === void 0 ? void 0 : props.name, " ").concat(props === null || props === void 0 ? void 0 : props.ariaLabel), checkedIcon: _jsx(RadioButtonChecked, {}), icon: _jsx(RadioButtonIcon, {}), sx: {
                    ".MuiSvgIcon-root": {
                        fontSize: "1rem",
                    },
                    padding: "0.25rem" /** 4px */,
                    "&.Mui-disabled": {
                        color: Color.component.gray_light,
                    },
                    ":not(.Mui-disabled)": {
                        "&.Mui-checked": {
                            color: Color.primary.main,
                        },
                        ":not(.Mui-checked)": {
                            "&:hover": {
                                color: Color.component.gray_dark,
                            },
                            ":not(hover)": {
                                color: Color.component.gray,
                            },
                        },
                    },
                } }), label: props === null || props === void 0 ? void 0 : props.name, sx: __assign(__assign(__assign({}, (!hasMarginProps(props)
                ? { marginLeft: 0, marginRight: 0 }
                : MarginProps(props))), PaddingProps(props)), { ".MuiFormControlLabel-label": {
                    // marginLeft: "0.25rem", /** 4px */
                    color: "".concat(Color.text.secondary, "!important"),
                } }) }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
